export const INVOICING_MAILTO_EMAIL = 'makelaars@smooved.be';
